<template>
  <component :is="componentToRender" :id="channelId" />
</template>

<script>
import { computed, defineAsyncComponent } from 'vue';
import { useStore } from 'vuex';
import MainComponent from '@/components/MainComponent.vue';
import ChannelComponent from '@/components/ChannelComponent.vue';

// Async load dashboards to avoid circular dependencies
const MeetingsDashboard = defineAsyncComponent(() => import('@/components/meeting/dashboard/MeetingsDashboard.vue'));
const ZvonalitikDashboard = defineAsyncComponent(() => import('@/components/zvonalitik/ZvonalitikDashboard.vue'));

export default {
  setup() {

    const store = useStore();

    const configData = computed(() => store.getters['app/configData']);

    const componentToRender = computed(() => {
      const chatbotName = configData.value?.chatbot_name;

      // Redirect to specific dashboards based on chatbot
      if (chatbotName === 'zvonalitik') {
        return ZvonalitikDashboard;
      }
      if (chatbotName === 'meetscribe') {
        return MeetingsDashboard;
      }

      // Default: channel or main component
      console.log(configData.value.channel_id);
      return configData.value && configData.value.channel_id ? ChannelComponent : MainComponent;
    });

    const channelId = computed(() => configData.value?.channel_id || null);

    return {
      componentToRender,
      channelId
    };
  }
};
</script>
